import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";

interface HeaderProps {
  title: string;
  subtitle?: string;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  onButtonClick?: () => void;
  buttonDisabled?: boolean;
  additionalButtons?: React.ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  buttonText,
  onButtonClick,
  buttonDisabled,
  additionalButtons,
}: HeaderProps) {
  return (
    <div className="container mx-auto">
      <div className="flex items-center justify-between py-4 pt-0 mb-4">
        <div>
          <h1 className="text-3xl font-regula">{title}</h1>
          {subtitle && <p className="text-muted-foreground text-sm">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2">
          {additionalButtons}
          {buttonText && (
            <Button size="lg" onClick={onButtonClick} disabled={buttonDisabled} className="uppercase rounded-lg">
              <span className="inline-block md:hidden">
                <PlusIcon className="size-4" />
              </span>
              <span className="hidden md:inline">{buttonText}</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
